import { Overlay } from '@/shared/components/overlay'
import { Spinner } from '@material-tailwind/react'

export const PageLayoutOverlay = () => {
  return (
    <Overlay className='md:ml-[14.60rem] md:p-12 md:rounded-2xl md:m-2 bg-gray-50 border-none'>
      <Spinner />
    </Overlay>
  )
}
